<script>
  import {faBook} from '@fortawesome/free-solid-svg-icons';

  export let type;
  export let size = null;
  export let align = null;
  export let style = null;

  let viewBox = '0 0 0 0';
  let path = [];

  $: content =
      type === 'book' && faBook;

  $: if (content) {
    viewBox = "0 0 " + content.icon[0] + " " + content.icon[1];
    path = content.icon[4];
  }

  $: containerStyles = [
    align ? `vertical-align: ${align};` : '',
    size ? `font-size: ${size}px;` : '',
    style,
  ].filter(Boolean).join('');

  $: classes = [
    'default',
    $$props.class,
  ].filter(Boolean).join(' ');
</script>

<i class="icon" style={containerStyles}>
  <svg class={classes} viewBox="{viewBox}" focusable="false">
    <path d="{path}"></path>
  </svg>
</i>

<style type="text/scss">
  i {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 13px;
  }
  .default {
    display: inline-block;
    height: 1em;
    width: 1em;
  }
</style>